import { Injectable, inject } from '@angular/core';
import { MessageService as Message, ConfirmationService } from 'primeng/api';
@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private readonly _message = inject(Message);
  private readonly _confirmationService = inject(ConfirmationService);

  error(message: string) {
    this._message.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000,
    });
  }

  success(message: string) {
    this._message.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
      life: 5000,
    });
  }

  uploading(message: string) {
    this._message.add({
      key: 'uploading',
      sticky: true,
      severity: 'info',
      summary: message,
    });
  }

  clear(key: string) {
    this._message.clear(key);
  }

  warning(message: string) {
    this._message.add({
      severity: 'warn',
      summary: 'Warning',
      detail: message,
      life: 5000,
    });
  }

  confirm(options: {
    message: string;
    header?: string;
    accept?: () => void;
    reject?: () => void;
  }) {
    this._confirmationService.confirm({
      message: options.message,
      header: options.header ?? 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: options.accept,
      reject: options.reject,
    });
  }

  information(options: {
    message: string;
    header?: string;
    accept?: () => void;
  }) {
    this._confirmationService.confirm({
      message: options.message,
      header: options.header ?? 'Information',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Ok',
      rejectVisible: false,
      accept: options.accept,
    });
  }

  customDialog(options: {
    message: string;
    header?: string;
    icon?: string;
    acceptLabel?: string;
    accept?: () => void;
  }) {
    this._confirmationService.confirm({
      message: options.message,
      header: options.header ?? 'Information',
      icon: options.icon ?? 'pi pi-info-circle',
      acceptLabel: options.acceptLabel ?? 'Ok',
      rejectVisible: false,
      accept: options.accept,
    });
  }
}
